// Step numbers match DigitalFormService.STEPS in the backend (`currentStep`).
export const DIGITAL_FORM_STEP = {
  POLICIES: 1,
  EMPLOYEE_INSURED: 2,
  DEPENDENTS: 3,
  DEPENDENT_COVERAGES: 4,
  BENEFICIARIES: 5,
  HEALTH_DECLARATION: 6,
  AGREEMENT_DECLARATION: 7
};

export const DIGITAL_FORM_STEP_TITLES = [
  { step: DIGITAL_FORM_STEP.POLICIES, title: 'Contratante y Pólizas' },
  { step: DIGITAL_FORM_STEP.EMPLOYEE_INSURED, title: 'Datos titular' },
  { step: DIGITAL_FORM_STEP.DEPENDENTS, title: 'Cargas' },
  {
    step: DIGITAL_FORM_STEP.DEPENDENT_COVERAGES,
    title: 'Asignación de coberturas'
  },
  { step: DIGITAL_FORM_STEP.BENEFICIARIES, title: 'Beneficiarios' },
  { step: DIGITAL_FORM_STEP.HEALTH_DECLARATION, title: 'Declaración Salud' },
  { step: DIGITAL_FORM_STEP.AGREEMENT_DECLARATION, title: 'Consentimiento' }
];

// The dependent coverage step only applies when the form has dependents.
// `hasDependents` is null while unknown: the step is kept to preserve the
// original flow.
const skipsDependentCoverages = (hasDependents) => hasDependents === false;

export const resolveDigitalFormStep = (
  targetStep,
  currentStep,
  hasDependents
) => {
  if (
    targetStep !== DIGITAL_FORM_STEP.DEPENDENT_COVERAGES ||
    !skipsDependentCoverages(hasDependents)
  ) {
    return targetStep;
  }
  return currentStep > DIGITAL_FORM_STEP.DEPENDENT_COVERAGES
    ? DIGITAL_FORM_STEP.DEPENDENTS
    : DIGITAL_FORM_STEP.BENEFICIARIES;
};

export const getVisibleDigitalFormSteps = (hasDependents) =>
  DIGITAL_FORM_STEP_TITLES.filter(
    ({ step }) =>
      step !== DIGITAL_FORM_STEP.DEPENDENT_COVERAGES ||
      !skipsDependentCoverages(hasDependents)
  );
